var _rect, _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWarningCircle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "13px",
    height: "14px",
    viewBox: "0 0 13 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    transform: "rotate(0) scale(1, 1)",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 0.5,
    width: 13,
    height: 13,
    rx: 6.5,
    fill: "#20e290"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4253_9111)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.9662 8.15615H5.84239L5.6792 3.50781H7.12939L6.9662 8.15615Z",
    fill: "#ffffff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.96657 7.99041C6.59308 7.99041 6.21792 7.99041 5.84444 7.99041C5.89995 8.04593 5.95715 8.10313 6.01267 8.15864C5.99417 7.63543 5.97566 7.11054 5.95715 6.58733C5.92687 5.75288 5.89827 4.91843 5.86799 4.08399C5.86126 3.89388 5.85453 3.70209 5.8478 3.51199C5.79228 3.5675 5.73508 3.6247 5.67957 3.68022C6.10184 3.68022 6.52411 3.68022 6.94638 3.68022C7.00862 3.68022 7.06919 3.68022 7.13144 3.68022C7.07592 3.6247 7.01872 3.5675 6.9632 3.51199C6.9447 4.0352 6.92619 4.56009 6.90768 5.0833C6.8774 5.91775 6.8488 6.7522 6.81852 7.58664C6.81179 7.77675 6.80506 7.96854 6.79833 8.15864C6.78992 8.37567 7.12639 8.37567 7.1348 8.15864C7.15331 7.63543 7.17181 7.11054 7.19032 6.58733C7.2206 5.75288 7.2492 4.91843 7.27948 4.08399C7.28621 3.89388 7.29294 3.70209 7.29967 3.51199C7.30304 3.42114 7.2206 3.34375 7.13144 3.34375C6.70917 3.34375 6.28689 3.34375 5.86462 3.34375C5.80238 3.34375 5.74181 3.34375 5.67957 3.34375C5.5904 3.34375 5.50797 3.42114 5.51133 3.51199C5.52984 4.0352 5.54834 4.56009 5.56685 5.0833C5.59713 5.91775 5.62573 6.7522 5.65601 7.58664C5.66274 7.77675 5.66947 7.96854 5.6762 8.15864C5.67957 8.24949 5.75022 8.32688 5.84444 8.32688C6.21792 8.32688 6.59308 8.32688 6.96657 8.32688C7.18191 8.32688 7.18191 7.99041 6.96657 7.99041Z",
    fill: "#ffffff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.99688 9.23438H5.8125V10.2976H6.99688V9.23438Z",
    fill: "#ffffff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.99714 10.1297C6.60179 10.1297 6.20812 10.1297 5.81277 10.1297C5.86828 10.1852 5.92548 10.2424 5.981 10.2979C5.981 9.94291 5.981 9.58794 5.981 9.23464C5.92548 9.29016 5.86828 9.34736 5.81277 9.40288C6.20812 9.40288 6.60179 9.40288 6.99714 9.40288C6.94163 9.34736 6.88443 9.29016 6.82891 9.23464C6.82891 9.58962 6.82891 9.94459 6.82891 10.2979C6.82891 10.5149 7.16538 10.5149 7.16538 10.2979C7.16538 9.94291 7.16538 9.58794 7.16538 9.23464C7.16538 9.14379 7.08799 9.06641 6.99714 9.06641C6.60179 9.06641 6.20812 9.06641 5.81277 9.06641C5.72192 9.06641 5.64453 9.14379 5.64453 9.23464C5.64453 9.58962 5.64453 9.94459 5.64453 10.2979C5.64453 10.3887 5.72192 10.4661 5.81277 10.4661C6.20812 10.4661 6.60179 10.4661 6.99714 10.4661C7.21417 10.4661 7.21417 10.1297 6.99714 10.1297Z",
    fill: "#ffffff"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4253_9111"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 2.38971,
    height: 7.64706,
    fill: "#ffffff",
    transform: "translate(5.35303 3.17578)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWarningCircle);
export default __webpack_public_path__ + "static/media/warning_circle.990770a9db0867c9d6946b504e98caee.svg";
export { ForwardRef as ReactComponent };